import SignupForm from "../components/SignupForm/SignupForm"
import { Col, Container, Row } from "react-bootstrap"
import loginImg from "../assets/login (1).png"
function SignupAsStudent() {
  return (
   
        <Container fluid >
            <Row className="px-0">
                           <Col md={7} className="px-0">
                <div  className="w-100 d-flex justify-content-center"style={{height: "100vh",overflowY:"scroll"}}>
                <div className="login_form_section_container">

{/* <h5 className="text-center title">مرحبا بك !</h5>
<p className="text-center paragraph">قم بادخال البيانات المطلوبه حتي تتمكن من معرفه كل التفاصيل الخاصه بالطالب !</p> */}
                
                <SignupForm/>
                    </div>
                </div>
                </Col>
                <Col md={5} className="px-0">
                <div className=" w-100 d-flex justify-content-center align-items-center login_img_container"style={{backgroundColor:"#e63967",height: "100vh",borderTopRightRadius:"24px",borderBottomRightRadius:"24px"}}>
<img src={loginImg}alt=""className="w-75"/>
                </div>
                </Col>
     
            </Row>
        </Container>
  )
}

export default SignupAsStudent
